import { RootState } from '@interfaces/rootState';

export const InsuranceAuthStatusTypesSelector = ({ insuranceAuthStatus }: RootState) => insuranceAuthStatus.insuranceAuthStatusTypes;
